import { CommonModule } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface GalleryItem {
  videoUrl: string;
  thumbnailUrl: string;
  title: string;
  description:string;
}

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  Math = Math;
  galleryItems: GalleryItem[] = [
    {
      videoUrl: 'assets/images/gallery/meena_story.mp4',
      thumbnailUrl: 'assets/images/gallery/meena_story.webp',
      title: 'No More Acidity & Constipation – Meena’s Tummy Detox Story!',
      description: `🌿✨ A Happy Gut, A Happy Life! ✨🌿 Meet Meena Agarvat, who struggled with acidity & constipation until she tried Tummy Detox! 🌱💚 After a month, she feels lighter, healthier, and free from discomfort. 😊🎉 Join Meena and thousands improving their digestion with Herbs LYF’s Tummy Detox! 🌿💚 Order now on Amazon, Flipkart, or 🌐 www.herbslyf.com.`
    },
    {
      videoUrl: 'assets/images/gallery/healthy_gut.mp4',
      thumbnailUrl: 'assets/images/gallery/healthy_gut.png',
      title: 'Feeling heavy and bloated? It’s time for a gentle reset! 🌿',
      description: `Herbs.lyf’s Tummy Detox is your natural solution to relieve constipation, improve digestion, and bring your gut back to balance. 💚 Safe, effective, and powered by nature! 🍃✨`
    },
    {
      videoUrl: 'assets/images/gallery/transform_gut.mp4',
      thumbnailUrl: 'assets/images/gallery/transform_gut.png',
      title: 'Transform your #gut #health, the natural way! |Tummy Detox',
      description: `Trust Herbs.lyf's Tummy Detox to gently relieve constipation 🌿and restore digestive balance. With the power of nature,💚 we bring you a reliable, safe, and effective solution.✨💪`
    },
    {
      videoUrl: 'assets/images/gallery/boost_digestive.mp4',
      thumbnailUrl: 'assets/images/gallery/boost_digestive.png',
      title: `Boost Your #Digestive #Health Naturally with Herbs.Lyf's Detox Blend |`,
      description: `It’s amazing how a healthy gut can change everything. 🌿 With a gentle blend of Ajowain, Saunf, Senna, Rose, Yashtimadhu, and Haritaki, you can start feeling more balanced and comfortable in no time. 💪 It’s like giving your body a little extra love. 🌸 If you want to feel lighter and more at ease, this natural remedy might be just what you need!✨💚`
    },
    {
      videoUrl: 'assets/images/gallery/better_digestion.mp4',
      thumbnailUrl: 'assets/images/gallery/better_digestion.png',
      title: 'Natural Tummy Detox for Better Digestion and Energy|',
      description: `Revitalize your digestive 💚 health with our all-natural tummy detox formula. Crafted with a blend of potent 🌿 ingredients of Meshasringi, Methi, Tejpatta, Jamun, Bilva, and Kadi Patta, 😊 it's designed to cleanse and rejuvenate your system.💪🍃`
    },
    {
      videoUrl: 'assets/images/gallery/magic_tummy.mp4',
      thumbnailUrl: 'assets/images/gallery/magic_tummy.png',
      title: 'Exploring the Magic of Tummy Detox |',
      description: `Digestive wellness with Tummy Detox by Herbs LYF! Natural solution to bloating, gas, and digestive discomfort. Discover the powerful ingredients Yashtimadhu, Saunf, Haritaki, Ajwain, Senna, and Rose their harmonious benefits as we delve into how Tummy Detox can transform your digestive health.`
    },
  ];

  selectedVideo: GalleryItem | null = null;
  isLoading = true;
  currentFilter = 'all';
  currentSlide = 0;
  itemsPerPage = 4;
  slidesArray: number[] = [];

  constructor(private modalService: NgbModal) {
    this.updateItemsPerPage(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateItemsPerPage(event.target.innerWidth);
    this.updateSlidesArray();
    // Reset to first slide when resizing to prevent out-of-bounds issues
    this.currentSlide = 0;
  }

  private updateItemsPerPage(width: number) {
    if (width <= 768) {
      this.itemsPerPage = 1;
    } else if (width <= 1200) {
      this.itemsPerPage = 2;
    } else {
      this.itemsPerPage = 4;
    }
  }

  ngOnInit() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
    this.updateSlidesArray();
  }

  private updateSlidesArray() {
    const totalSlides = Math.ceil(this.galleryItems.length / this.itemsPerPage);
    this.slidesArray = Array(totalSlides).fill(0);
  }

  getPageItems(pageIndex: number): GalleryItem[] {
    const startIndex = pageIndex * this.itemsPerPage;
    return this.galleryItems.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get canShowPrevious(): boolean {
    return this.currentSlide > 0;
  }

  get canShowNext(): boolean {
    return this.currentSlide < (this.slidesArray.length - 1);
  }

  nextSlide() {
    if (this.canShowNext) {
      this.currentSlide++;
    }
  }

  prevSlide() {
    if (this.canShowPrevious) {
      this.currentSlide--;
    }
  }

  openVideo(content: any, item: GalleryItem) {
    this.selectedVideo = item;
    this.modalService.open(content, {
      size: 'lg',
      centered: true,
      windowClass: 'video-modal'
    });
  }

  closeVideo() {
    this.modalService.dismissAll();
    this.selectedVideo = null;
  }

  filterVideos(category: string) {
    this.currentFilter = category;
    this.currentSlide = 0;
    this.updateSlidesArray();
  }
}
